import { Button, styled, Typography } from "@mui/material";
import InvoiceEditIcon from "assets/icons/invoice/InvoiceEditIcon";
import PrinterIcon from "assets/icons/invoice/PrinterIcon";
import { Dispatch, forwardRef, LegacyRef, SetStateAction, useRef } from "react";
import ReactToPrint from "react-to-print";
import pattern1 from "assets/InvoicePattern/pattern001.jpg";

// @ts-ignore
import ReactToPdf from "react-to-pdf";
import FactorSettingInfoList from "./FactorSettingInfoList";
import BasicButton from "components/BasicInputs/BasicButton";
import useFishPrint from "components/Factor2/print/useFishPrint";
import { factorTemplate } from "../FactorViewComponent";
import { store } from "store/store";

const SettingContainer = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    borderRadius: theme.shape.borderRadius,
    gridTemplateRows: "10% 80% 10%",
}));
const TitleSection = styled(Typography)(({ theme }) => ({
    height: "55px",
    display: "flex",
    alignItems: "center",
    padding: "0 24px 0 24px",
}));
const MiddleSection = styled(Typography)(({ theme }) => ({
    minHeight: "400px",
    padding: "40px",
    margin: "0 24px",
    borderRadius: theme.shape.borderRadius,
    borderWidth: "1px",
    borderColor: "#cacaca",
    borderStyle: "solid",
}));
const ActionSection = styled(Typography)(({ theme }) => ({
    display: "flex",
    padding: "0 24px",
    height: "120px",
    flexDirection: "column",
    justifyContent: "space-evenly",
}));
const ActionButton = styled(Button)(({ theme }) => ({
    height: "44px",
    fontSize: "16px",
}));
const CarouselContainer = styled("div")(({ theme }) => ({
    cursor: "pointer",
    marginBottom: "36px",
    position: "relative",
}));
const CarouselLayer = styled("div")(({ theme }) => ({
    position: "absolute",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    justifyContent: "center",
    width: "50%",
    height: "100%",
    borderRadius: theme.shape.borderRadius,
    backgroundColor: "#d6dbe26a",
    zIndex: 2,
}));
const SlideImage = styled("img")(({ theme }) => ({
    height: "100%",
    width: "auto",
}));
const FactorSettingInfo = forwardRef(
    (
        {
            factor,
            invoiceRef,
            setPattern,
            setFactorSetting,
            setChoseTemplate,
        }: {
            factor: any,
            invoiceRef: any;
            setPattern: Dispatch<SetStateAction<number>>;
            setFactorSetting: Dispatch<SetStateAction<factorSettingType>>;
            setChoseTemplate: Dispatch<SetStateAction<factorTemplate>>;
        },
        ref: LegacyRef<ReactToPrint>
    ) => {
        const listRef = useRef(null);
        const { contentRef, content } = useFishPrint();
        const { contentRef: contentRefSecondVersion, content: contentSecondVersion } = useFishPrint({ secondVersion: true });
        const appReducer = store.getState().appReducer as any
        const appSettings = appReducer.appSettings
        const { printSecondVersion } = appSettings
        return (
            <>
                <SettingContainer>
                    <TitleSection variant="body1">تنظیمات چاپ</TitleSection>
                    <MiddleSection>
                        <CarouselContainer
                        >
                            <Typography className="mb-3" color="primary">انتخاب قالب</Typography>
                            <div className="flex flex-row gap-2">
                                <div className="group">

                                    <CarouselLayer className="opacity-0 group-hover:opacity-100" onClick={() => setChoseTemplate("template1")}>

                                        <div style={{ padding: "5px" }} />
                                        <Typography color="primary">قالب شماره یک</Typography>
                                    </CarouselLayer>

                                    <SlideImage
                                        style={{ width: '100%' }} src={pattern1} />
                                </div>
                                <div className="group">
                                    <CarouselLayer className="opacity-0 group-hover:opacity-100" onClick={() => setChoseTemplate("template2")}>
                                        <div style={{ padding: "5px" }} />
                                        <Typography color="primary">قالب شماره دو</Typography>
                                    </CarouselLayer>

                                    <SlideImage
                                        className="overly-hover:opa"
                                        style={{ width: '100%' }} src={pattern1} />
                                </div>
                            </div>

                        </CarouselContainer>
                        <BasicButton
                            onClick={() => setFactorSetting("choosePattern")}
                            fullWidth variant="outlined" className="mt-3 [&>svg]:w-3 [&>svg]:h-3">
                            <InvoiceEditIcon />
                            <span>
                                ویرایش قالب
                            </span>
                        </BasicButton>
                        <FactorSettingInfoList ref={listRef} />

                    </MiddleSection>
                    <ActionSection>
                        <div className="flex justify-between ">
                            <ReactToPrint
                                ref={ref}
                                pageStyle={`@page { size: 148mm 210mm; margin: 10mm 5mm 5mm 5mm;  } `}
                                trigger={() => (
                                    <ActionButton variant="contained" style={{ gap: "4px" }} className="mt-3 w-1/2 mx-1">
                                        <PrinterIcon />
                                        <span>چاپ فاکتور A5</span>
                                    </ActionButton>
                                )}
                                content={() => invoiceRef.current}
                            />
                            <ReactToPrint
                                ref={ref}
                                trigger={() => (
                                    <ActionButton variant="contained" style={{ gap: "4px" }} className="mt-3 w-1/2 mx-1">
                                        <PrinterIcon />
                                        <span>چاپ فاکتور A4</span>
                                    </ActionButton>
                                )}
                                content={() => invoiceRef.current}
                            />
                            <div className="hidden">{content}</div>
                        </div>
                        {printSecondVersion && <>
                            <div className="hidden">{contentSecondVersion}</div>
                            <ReactToPrint
                                ref={ref}
                                trigger={() => (
                                    <BasicButton  id="MySecondPrintItem" fullWidth variant="outlined" className="w-0 h-0 hidden">
                                    </BasicButton>
                                )}
                                content={() => contentRefSecondVersion.current}
                            />
                        </>
                        }
                        <ReactToPrint

                            ref={ref}
                            onAfterPrint={() => {
                                if (printSecondVersion) {
                                    const element = document.getElementById("MySecondPrintItem")
                                    if (element) {
                                        element.click()
                                    }
                                }
                            }}
                            trigger={() => (
                                <BasicButton fullWidth variant="outlined" className="mt-3">
                                    <span>فیش پرینت فاکتور</span>
                                </BasicButton>
                            )}
                            content={() => contentRef.current}
                        />
                        {/* <Button variant="outlined" color="primary" className="mt-3"
                            onClick={() => ReactToPdf(invoiceRef, { filename: `${factor.accountingCode} - ${factor.title}.pdf` })}>
                            ذخیره به صورت PDF
                        </Button> */}
                    </ActionSection>
                </SettingContainer>
            </>
        );
    }
);

export default FactorSettingInfo;
